import Service from "../../../Services/index";

const preOrder = {
    namespaced: true,
    state: {
        table: [],
        data: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            material_id: "",
            date: ""
        },
    },
    mutations: {
        GET_PRE_ORDER: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_PRE_ORDER_BY_ID: (state, res) => {
            state.data = res;
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                material_id: "",
                date: ""
            }
        }
    },
    actions: {
        setPreOrder({commit}, page) {
            return Service.PreOrder.getPreOrder(page).then(response => {
                commit("GET_PRE_ORDER", response);
            });
        },
        create({commit}, data) {
            return Service.PreOrder.createPreOrder(data);
        },
        show({commit}, id) {
            return Service.PreOrder.showPreOrder(id).then(response => {
                commit("GET_PRE_ORDER_BY_ID", response)
            })
        },
        update({commit}, {id, data}) {
            //console.log(data);
            return Service.PreOrder.updatePreOrder(id, data);
        },
        delete({commit}, id) {
            return Service.PreOrder.deletePreOrder(id);
        },
        search({commit}, {page = "", material_id, date}) {
            return Service.PreOrder.searchPreOrder(page, material_id, date)
                .then(data => {
                    commit("GET_PRE_ORDER", data);
                })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        }
    }
};

export default preOrder;
